<template>
  <div class="col_2 w934 onsite_b task_jihua_list">
    <h5 class="none_ts" v-if="cntData <= 0 || !lists" style="text-align: center;">
      <img src="@/assets/images/none_data.jpg" alt="">
      <h4>暂无计划</h4>
    </h5>
    <dl v-for="item in lists" :key="item.id">
      <dt>
        <span class="btn_end" v-if="item.process == 100">已完成</span>
        <img src="@/assets/images/course_default.png" v-if="!item.trainingPlan.coverUrl || item.trainingPlan.coverUrl == ''" />
        <img :src="item.trainingPlan.coverUrl" v-if="item.trainingPlan.coverUrl && item.trainingPlan.coverUrl !== ''">
      </dt>
      <dd class="narrow">
        <h3>{{item.trainingPlan.title}}</h3>
        <p class="time_t" v-if="item.trainingPlan">{{ dateFormat(new Date(item.trainingPlan.beginDate), 'yyyy-MM-dd') }} 至 {{ dateFormat(new Date(item.trainingPlan.endDate), 'yyyy-MM-dd') }}</p>
        <a class="a_detail" @click="to({id: item.id, planId: item.trainingPlan.id})" style="cursor: pointer;">查看进度 {{item.process}}%</a>
      </dd>
    </dl>
  </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  import Paginate from 'vuejs-paginate'
  import utils from '@/utils'
  import { getCookie } from '@/store/cookies'
  export default {
    components: { Paginate },
    data () {
      return {
        lists: [],
        filters: {
          pageNo: 1,
          pageSize: 12,
          itemType: '05'
        },
        pages: 0,
        cntData: ''
      }
    },
    created () {
      this.search(this.filters)
    },
    methods: {
      dateFormat: utils.dateFormat,
      clickCallback (pageNum) {
        this.filters.pageNo = pageNum
        this.search(this.filters)
      },
      search (filters) {
        api.post(config.bylApiPath, '/studyItemPermissions/myTasks', filters, (r) => {
          this.lists = r.data
          this.cntData = r.cntData // 总数
          this.pages = Math.ceil(r.cntData / this.filters.pageSize) // 页数
        })
      },
      to (o) {
        var path = getCookie('org') ? this.$OR.getUrl(getCookie('org').businessId) : ''
        this.$router.push({
          path: path + '/planrecord/' + o.id + '/' + o.planId
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/modules/task/myPlan.vue